import styled from 'styled-components';
import { CommonPluginContainer } from './CommonPluginContainer';

interface OneArmedBanditContainerProps {
  isEdition: boolean | undefined;
}

interface OneArmedBanditBackgroundProps {
  color: string;
}

export const OneArmedBanditContainer = styled(CommonPluginContainer)<OneArmedBanditContainerProps>`
  position: relative;
  height: 81vh;
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;

  ${(props): string => {
    if (props.isEdition === true) {
      return `
        &:hover {
          -webkit-box-shadow: inset 0 0 2px 0 black;
          box-shadow: inset 0 0 2px 0 black;
        }
      `;
    }
    return '';
  }}
`;
OneArmedBanditContainer.displayName = 'OneArmedBanditContainer';

export const OuterStripe = styled.div`
  border: 1.2vw solid #ffffff;
  background-color: #ffffff;
  border-radius: 2.9vw;
  position: absolute;
  top: 23.6vh;
  bottom: 14.4vh;
  left: 1.2vw;
  right: 1.2vw;
`;
OuterStripe.displayName = 'OuterStripe';

export const InnerStripe = styled.div`
  background-color: #313A49;
  border: 2.1vw solid #313A49;
  border-radius: 2.3vw;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
InnerStripe.displayName = 'InnerStripe';

export const OneArmedBanditBackground = styled.div<OneArmedBanditBackgroundProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 1.6vw;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${({ color }): string => {
    return `
      background-color: ${color};
      border: 3vw solid ${color};
    `;
  }}
`;
OneArmedBanditBackground.displayName = 'OneArmedBanditBackground';

export const OneArmedBanditSpinner = styled.div`
  width: 23vw;
  height: 100%;
  background-color: black;
  border-radius: 2vw;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
`;
OneArmedBanditSpinner.displayName = 'OneArmedBanditSpinner';

export const NeedleContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  height: 8vh;
  top: 41vh;
`;
NeedleContainer.displayName = 'NeedleContainer';

export const LeftNeedleContainer = styled(NeedleContainer)`
  left: -0.5vw;
  transform: rotate(180deg);
`;
LeftNeedleContainer.displayName = 'LeftNeedleContainer';

export const RightNeedleContainer = styled(NeedleContainer)`
  right: -0.5vw;
`;
RightNeedleContainer.displayName = 'RightNeedleContainer';

export const SlotImage = styled.img<{speed: number, isPlaying: boolean}>`
  height: 15vh;
  width: 15vw;
  filter: blur(2px);
  ${({ speed, isPlaying }): string => {
    const blur = isPlaying
      // eslint-disable-next-line no-magic-numbers
      ? speed / 15
      : 0;
    return `filter: blur(${blur}vh)`;
  }}
`;
SlotImage.displayName = 'SlotImage';

export const SlotsContainer = styled.div`
  top: -7.5vh;
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TopSpinnerShadow = styled.div`
  -webkit-box-shadow: inset 0px 40px 25px -18px #000000; 
  box-shadow: inset 0px 40px 25px -18px #000000;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 1;
`;

export const BottomSpinnerShadow = styled.div`
  -webkit-box-shadow: inset 0px 40px 25px -18px #000000; 
  box-shadow: inset 0px -40px 25px -18px #000000;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 1;
`;
